module.exports = __webpack_public_path__ + "media/icons/card-4-1dc00e67.png";